import { Model } from "@quest/platform-murka/dist";

export class GameParserModel extends Model {
  private isSelectionScreenAvailable: boolean = false;
  private allSelectionfreeSpins: number[] = [];
  private linesWinUniquePositionsGame: number[][] = [];
  // Stack Feature
  private isStackSym: boolean = false;
  private commonOffsetsOfStackAndWin: number[][][] = [];
  private stackSymOffsets: number[][] = [];
  private isStackSymFG: boolean = false;
  private stackSymOffsetsFG: number[][] = [];

  // private flowerEaten:number[]=[];
  private CollectedFlowers: number[] = [];
  private WildOnReel: number[] = [];
  private PreWildOnReel: number[] = [];
  private PreWildPresentOnReel: boolean[] = [];
  private PreCollectedFlowers: number[] = [];
  private TotalFlowerSpace: number[] = [];
  private OnionOffset: number[][] = [];

  // Stack Feature model
  private isStickyWildAvailable: boolean = false;
  private WildLockPos: number[][] = [];
  private pickChoice: number;
  private flowerCollectMeterData: any;
  private preflowerCollectMeterData: any;
  private preWildGrid: number[][];
  private gridForAllBet: number[][];
  private currentBetGrid: number[][];
  private IsWildPresentOnReel: boolean[];
  protected maxGameRTP: String = "";
  protected minGameRTP: String = "";
  private isOutOfBalance: boolean = false;

  //set true if stack symbol present
  public setStackSymPresent(value: boolean): boolean {
    return (this.isStackSym = value);
  }

  //get if stack symbol present
  public getStackSymPresent(): boolean {
    return this.isStackSym;
  }

  //set stack symbol offsets
  public setStackSymOffsets(value: number[][]): void {
    this.stackSymOffsets = value;
  }

  //get stack symbol offsets
  public getStackSymOffsets(): number[][] {
    return this.stackSymOffsets;
  }

  //set true if stack symbol present
  public setStackSymPresentFG(value: boolean): boolean {
    return (this.isStackSymFG = value);
  }

  //get if stack symbol present
  public getStackSymPresentFG(): boolean {
    return this.isStackSymFG;
  }

  //set stack symbol offsets
  public setStackSymOffsetsFG(value: number[][]): void {
    this.stackSymOffsetsFG = value;
  }

  //get stack symbol offsets
  public getStackSymOffsetsFG(): number[][] {
    return this.stackSymOffsetsFG;
  }

  //set stack symbol offsets
  public setCommonOffsetsOfStackAndWin(value: number[][][]): void {
    this.commonOffsetsOfStackAndWin = value;
  }

  //get stack symbol offsets
  public getCommonOffsetsOfStackAndWin(): number[][][] {
    return this.commonOffsetsOfStackAndWin;
  }

  /**
   * setLinesWinUniquePositions method overrided to initialize the linesWinUniquePositions with intial value.
   * @param value
   */
  public setLinesWinUniquePositions(value: number[][]): void {
    this.linesWinUniquePositionsGame = value;
  }

  /**
   * getLinesWinAllUniquePositions method overrided to initialize the linesWinUniquePositions with intial value.
   * @param value
   */
  public getLinesWinAllUniquePositions(): number[][] {
    return this.linesWinUniquePositionsGame;
  }

  /**getter setter for selection screen */
  public setSelectionScreenAvailable(value: boolean): void {
    this.isSelectionScreenAvailable = value;
  }
  public setIsFreeSpintriggered(value: boolean) {
    this.freeSpinTrigger = value;
  }
  public getSelectionScreenAvailable(): boolean {
    return this.isSelectionScreenAvailable;
  }

  public setAllSelectionfreeSpins(value: number[]): void {
    this.allSelectionfreeSpins = value;
  }

  public getAllSelectionfreeSpins(): number[] {
    return this.allSelectionfreeSpins;
  }

  public setIsStickyWildAvailable(value: boolean) {
    this.isStickyWildAvailable = value;
  }
  public getIsStickyWildAvailable(): boolean {
    return this.isStickyWildAvailable;
  }
  public setWildLockPos(value: number[][]) {
    this.WildLockPos = value;
  }
  public getWildLockPos(): number[][] {
    return this.WildLockPos;
  }
  public setPickChoice(value: number) {
    this.pickChoice = value;
  }
  public getPickChoice(): number {
    return this.pickChoice;
  }
  // getter setter for the flower collect feature
  public setWildOnReel(value: number[]): void {
    this.WildOnReel = value;
  }

  public getWildOnReel(): number[] {
    return this.WildOnReel;
  }
  public setCollectedFlowers(value: number[]): void {
    this.CollectedFlowers = value;
  }

  public getCollectedFlowers(): number[] {
    return this.CollectedFlowers;
  }
  public setTotalFlowerSpace(value: number[]): void {
    this.TotalFlowerSpace = value;
  }

  public getTotalFlowerSpace(): number[] {
    return this.TotalFlowerSpace;
  }
  // getter setter for the flower collect feature
  public setIsWildPresentOnReel(value: boolean[]): void {
    this.IsWildPresentOnReel = value;
  }

  public getIsWildPresentOnReel(): boolean[] {
    return this.IsWildPresentOnReel;
  }
  // getter setter for the flower collect feature
  public setPreWildPresentOnReel(value: boolean[]): void {
    this.PreWildPresentOnReel = value;
  }

  public getPreWildPresentOnReel(): boolean[] {
    return this.PreWildPresentOnReel;
  }
  public setPreWildOnReel(value: number[]): void {
    this.PreWildOnReel = value;
  }

  public getPreWildOnReel(): number[] {
    return this.PreWildOnReel;
  }
  public setPreCollectedFlowers(value: number[]): void {
    this.PreCollectedFlowers = value;
  }

  public getPreCollectedFlowers(): number[] {
    return this.PreCollectedFlowers;
  }
  public setOnionOffset(value: number[][]): void {
    this.OnionOffset = value;
  }
  public getOnionOffset(): number[][] {
    return this.OnionOffset;
  }
  public setFlowerCollectMeterData(value: any): void {
    this.flowerCollectMeterData = value;
  }
  public getFlowerCollectMeterData(): any {
    return this.flowerCollectMeterData;
  }
  public setPreFlowerCollectMeterData(value: any): void {
    this.preflowerCollectMeterData = value;
  }
  public getPreFlowerCollectMeterData(): any {
    return this.preflowerCollectMeterData;
  }
  public setPreWildGrid(value: number[][]): void {
    this.preWildGrid = value;
  }
  public getPreWildGrid(): number[][] {
    return this.preWildGrid;
  }

  public setGridForAllBet(value: any): void {
    this.gridForAllBet = value;
  }
  public getGridForAllBet(): any {
    return this.gridForAllBet;
  }
  public setCurrentBetGrid(value: number[][]): void {
    this.currentBetGrid = value;
  }
  public getCurrentBetGrid(): number[][] {
    return this.currentBetGrid;
  }
  //Method returns a reset broken saved data in freegame
  public getUserGameCloseData() {
    let UserGameData = {
      name: "brokenData",
      data: {
        data: {
          AfterBrokenSpinsRemaining: 0,
          CurrentCount: 0,
          brokenInFg: false,
          currentTotal: 0,
        },
      },
    };
    return UserGameData;
  }

  public setMaxGameRTP(value: String): void {
    this.maxGameRTP = value;
  }
  public setMinGameRTP(value: String): void {
    this.minGameRTP = value;
  }
  public getMaxGameRTP(): String {
    return this.maxGameRTP;
  }
  public getMinGameRTP(): String {
    return this.minGameRTP;
  }
  public setBalance(value: number): void {
    super.setBalance(Number(value));
  }
  public setFreeBalance(value: number): void {
    super.setFreeBalance(Number(value));
  }
  public setCurrentWin(value: number): void {
    super.setCurrentWin(Number(value));
  }

  public setTotalWin(value: number): void {
    super.setTotalWin(Number(value));
  }

  public setGameWinAmt(value: number): void {
    super.setGameWinAmt(Number(value));
  }

  public setCurrentSpinTotalWinAmt(value: number): void {
    super.setCurrentSpinTotalWinAmt(Number(value));
  }

  public setIsOutOfBalance(value : boolean) {
        this.isOutOfBalance = value;
    }
  public getIsOutOfBalance():boolean{
        return this.isOutOfBalance;
    }
}
